import axios from 'axios'

export default class Cooperado {
  constructor (tokenBearer, url, id) {
    this.url = `${url}/api/unimed/compCooperado/${id}`
    this.urlUltimo = `${url}/api/unimed/compCooperado/ultima/${id}`
    this.urlPendetes = `${url}/api/unimed/compCooperado/pendentes/${id}`
    this.tokenBearer = tokenBearer
  }

  async getCooperados (args) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}?${args}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async getUltimoCooperado () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: this.urlUltimo,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async getPendentesCooperados () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: this.urlPendetes,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async putCooperado (data) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: this.url,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
